import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const productFormHeadingStyles = {
    '& .MuiTypography-root.MuiTypography-h6': {
        marginBottom: '24px',
        marginTop: '32px',
        '&:first-of-type': {
            marginTop: 0,
        },
    },
};

export const productCreateStyles = {
    width: '100%',
    '& .MuiCardContent-root': {
        width: '100%',
        marginBottom: '34px',
    },
    '& .RaShow-noActions': {
        margin: '0',
    },
    '& .popup-wrapper-top': {
        '& .popup-box--header': {
            padding: 0,
        },
    },
    '& .popup-box--header': {
        alignItems: 'center',
    },
    '& .padding-wrapper': {
        borderTop: `2px solid ${Palette.gray.gray75}`,
        padding: '40px 56px 56px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            padding: '24px 20px',
        },
    },
    '& .MuiTypography-root.MuiTypography-h5': {
        fontSize: '22px',
        letterSpacing: '-0.44px',
        marginBottom: '24px',
    },
    '& .product-form-container': {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '35px',
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& .MuiFormControl-root.operator-input': {
            width: '100%',
            maxWidth: '100%',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                maxWidth: '400px',
            },
        },
        '& .product-form-box': {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            gap: '20px',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                gap: '0',
            },
            '& .MuiBox-root': {
                margin: '0',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    flex: '1 1 100%',
                    marginRight: '0 !important',
                },
                '& > .MuiFormControl-root': {
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        width: '100%',
                    },
                },
                '& .date-picker': {
                    width: '100%',
                    marginBottom: '24px',
                    '& .rs-picker': {
                        width: '100%',
                        maxWidth: '100%',
                        minWidth: '100%',
                    },
                },
            },
        },
    },
};
